function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "meetingsTitle"
}, "meetings");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M30.057 28.298v1.677c0 2.064 1.68 3.743 3.743 3.743 1.997 0 3.634-1.572 3.737-3.544l.006-.199v-1.677h5.714v1.677c0 2.064 1.68 3.743 3.743 3.743 1.997 0 3.634-1.572 3.737-3.544l.006-.199v-1.677H55.8v15.87c0 2.696-2.128 4.894-4.796 5.008l-.217.005H49.2v1.604c0 2.695-2.128 4.894-4.796 5.008l-.217.005H25v-27.5h5.057zm12.56 20.896h-4.406v4.407h4.406v-4.407zm-6.614 0h-4.406v4.407h4.406v-4.407zm13.2-6.6h-4.406v4.407h4.406v-4.407zm-6.586 0h-4.406v4.407h4.406v-4.407zm-6.614 0h-4.406v4.407h4.406v-4.407zm13.2-6.586h-4.406v4.406h4.406v-4.406zm-6.586 0h-4.406v4.406h4.406v-4.406zM35.431 25v4.975c0 .9-.73 1.63-1.631 1.63-.9 0-1.63-.73-1.63-1.63V25h3.26zm13.2 0v4.975c0 .9-.73 1.63-1.631 1.63l-.14-.005c-.835-.071-1.49-.772-1.49-1.625V25h3.26z",
  transform: "translate(-212 -650) translate(212 650)"
}))));

var SvgPrimaryButtonUiMeetingsIcon = function SvgPrimaryButtonUiMeetingsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    "aria-labelledby": "meetingsTitle",
    role: "img",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "meetingsTitle"
  }, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrimaryButtonUiMeetingsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/primary-button-ui-meetings-icon.114ddbb4.svg";
export { ForwardRef as ReactComponent };